import { render, staticRenderFns } from "./ShippingTrackingTimeline.vue?vue&type=template&id=b29c1db4&scoped=true&lang=pug&"
import script from "./ShippingTrackingTimeline.vue?vue&type=script&lang=js&"
export * from "./ShippingTrackingTimeline.vue?vue&type=script&lang=js&"
import style0 from "./ShippingTrackingTimeline.vue?vue&type=style&index=0&id=b29c1db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29c1db4",
  null
  
)

export default component.exports